var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongratulation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 241,
    viewBox: "0 0 311 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25754_24642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.749 31.8673C238.25 30.66 239.251 29.7546 241.754 28.6982C241.253 27.491 240.377 26.5855 239.126 25.6801C237.248 26.7364 236.247 27.6419 234.996 29.4528C236.247 29.9055 236.748 30.5091 237.749 31.8673Z",
    fill: "url(#paint0_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26 16.9274C108.136 16.7765 109.138 16.9274 111.015 18.2855C111.39 17.2292 111.516 16.1728 111.265 14.8146C109.763 14.0601 108.762 13.6074 107.26 13.7583C107.511 14.8146 107.385 15.5692 107.26 16.9274Z",
    fill: "url(#paint1_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.09 66.5761C71.8409 66.2743 72.3415 66.4252 73.0925 66.7271C72.9673 65.218 72.5919 63.558 72.3415 62.9543C71.7158 62.9543 71.2151 63.2562 70.5894 63.7089C70.8397 64.3125 70.8397 65.218 71.09 66.5761Z",
    fill: "url(#paint2_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.163 20.0964C129.914 19.6437 130.414 19.4928 131.29 19.4928C131.29 19.0401 131.165 18.5873 130.915 18.2855C130.289 18.2855 129.663 18.4364 128.787 18.7383C129.163 19.191 129.288 19.6437 129.163 20.0964Z",
    fill: "url(#paint3_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48 46.3545C185.108 46.3545 186.109 46.3545 187.611 46.9581C187.861 46.0526 187.986 45.1472 187.736 44.3927C186.735 43.9399 185.358 43.6381 183.48 43.3363C183.981 44.6945 183.981 45.449 183.48 46.3545Z",
    fill: "url(#paint4_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.343 45.7509C173.468 46.9581 173.969 47.7127 174.845 48.3163C175.846 47.8636 176.472 47.2599 176.972 46.5054C176.472 45.2981 176.472 44.2418 176.472 42.5818C175.345 43.94 174.719 44.8454 173.343 45.7509Z",
    fill: "url(#paint5_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.771 52.3908C116.146 54.9563 115.771 56.4654 115.02 58.5781C118.524 58.5781 121.904 57.9744 123.406 57.2199C123.406 55.2581 123.03 53.5981 122.279 51.3345C120.652 52.2399 118.9 52.2399 115.771 52.3908Z",
    fill: "url(#paint6_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9638 22.36C68.9625 22.5109 68.4619 22.8127 67.7109 23.8691C68.3367 25.8309 68.7122 27.0381 69.0877 29C69.5883 28.5472 70.0889 28.3963 70.4644 28.3963C69.9638 26.1327 69.9638 24.7745 69.9638 22.36Z",
    fill: "url(#paint7_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 88.0186C217.461 85.3022 217.711 83.4913 217.962 81.0768C216.335 81.0768 215.333 81.3786 214.457 81.9822C214.582 83.4913 214.332 84.5477 213.581 86.2077C214.833 86.3586 215.584 86.8113 216.46 88.0186Z",
    fill: "url(#paint8_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57 14.8146C205.446 15.4183 206.322 15.2673 207.574 14.5128C206.948 11.9474 206.823 10.4383 207.073 7.87283C206.072 8.32556 205.321 8.17465 203.944 7.72192C203.819 10.1365 204.069 12.2492 204.57 14.8146Z",
    fill: "url(#paint9_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.729 60.0197C182.479 61.076 182.855 61.6796 183.105 62.8869C183.481 62.5851 183.856 62.5851 184.106 62.736C183.981 61.3778 183.606 60.6233 182.855 59.416C182.354 59.416 181.979 59.7178 181.729 60.0197Z",
    fill: "url(#paint10_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.832 126.536C214.081 126.385 213.706 126.083 213.205 125.329C212.705 126.234 212.579 126.989 212.329 128.498C212.705 129.252 213.08 129.403 213.831 129.554C213.956 128.196 214.206 127.29 214.832 126.536Z",
    fill: "url(#paint11_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.766 108.817C232.031 109.457 232.429 109.938 233.226 110.258C233.89 108.817 234.288 108.017 235.35 107.056C234.819 106.736 234.421 106.256 234.023 105.295C232.96 106.256 232.429 107.376 231.766 108.817Z",
    fill: "url(#paint12_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.111 39.8605C228.712 40.8209 228.712 41.3012 228.845 42.4217C229.907 42.1016 230.438 42.2616 231.102 42.5818C231.5 41.7814 231.633 41.1411 231.766 40.1806C230.704 40.3407 230.04 40.1806 229.111 39.8605Z",
    fill: "url(#paint13_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9224 53.7356C86.5241 52.7752 85.993 51.8147 85.0637 51.3345C84.3999 51.4946 83.8688 51.6546 83.0723 51.6546C83.4705 52.2949 83.4706 52.7752 83.205 53.8957C84.3999 53.5756 85.462 53.5756 86.9224 53.7356Z",
    fill: "url(#paint14_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.835 117.785C88.1712 116.984 87.6402 116.504 86.5781 116.504C85.6487 118.265 85.1177 119.225 83.9229 120.666C84.4539 120.986 84.8522 121.306 84.9849 121.627C86.3125 119.866 87.2419 119.065 88.835 117.785Z",
    fill: "url(#paint15_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8411 68.4893C71.1773 68.4893 70.6463 68.8094 70.1152 69.2896C70.779 70.09 70.9118 70.7303 71.0446 71.3706C71.7084 71.3706 72.1066 71.2106 72.9032 70.8904C72.2394 70.2501 71.9739 69.6098 71.8411 68.4893Z",
    fill: "url(#paint16_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2782 80.9752C93.4816 82.2558 92.154 83.2163 88.835 83.8566C89.2332 85.4574 90.0298 86.738 91.4902 88.0186C93.8799 87.0582 95.2075 86.4178 97.0661 84.3368C95.8713 83.6965 95.2075 82.8961 94.2782 80.9752Z",
    fill: "url(#paint17_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89 113.633C260.139 112.275 259.638 111.067 259.263 109.105C256.635 111.671 254.757 113.18 252.505 114.538C252.379 116.651 252.88 117.707 253.631 119.065C255.383 118.311 258.011 116.349 260.89 113.633Z",
    fill: "url(#paint18_linear_25754_24642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.129 68.0583C252.63 68.9638 252.755 70.0202 252.379 72.5856C253.255 72.5856 254.131 72.4347 255.008 71.6802C255.133 69.7184 255.008 68.662 254.507 66.8511C253.756 67.6056 253.255 67.9074 252.129 68.0583Z",
    fill: "url(#paint19_linear_25754_24642)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25754_24642",
    x1: 239.949,
    y1: 31.3768,
    x2: 235.726,
    y2: 26.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25754_24642",
    x1: 108.621,
    y1: 18.4139,
    x2: 109.986,
    y2: 13.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0478432,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#FF1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    stopColor: "#FF1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7936,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8443,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9592,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25754_24642",
    x1: 70.5627,
    y1: 65.2999,
    x2: 73.2697,
    y2: 64.8397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0709114,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1439,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2084,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4946,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6574,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7336,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9515,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25754_24642",
    x1: 130.177,
    y1: 19.9167,
    x2: 129.601,
    y2: 18.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0478432,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#FF1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    stopColor: "#FF1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7936,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8443,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9592,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25754_24642",
    x1: 185.447,
    y1: 46.8345,
    x2: 185.98,
    y2: 43.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1859,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3267,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5906,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7154,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9504,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25754_24642",
    x1: 174.586,
    y1: 44.0557,
    x2: 177.412,
    y2: 47.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25754_24642",
    x1: 118.717,
    y1: 51.1765,
    x2: 119.71,
    y2: 59.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25754_24642",
    x1: 68.145,
    y1: 26.2698,
    x2: 70.9329,
    y2: 25.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1131,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25754_24642",
    x1: 217.96,
    y1: 84.671,
    x2: 213.677,
    y2: 84.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0709114,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1439,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2084,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4946,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6574,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7336,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9515,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25754_24642",
    x1: 208.01,
    y1: 11.0079,
    x2: 203.353,
    y2: 11.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25754_24642",
    x1: 183.805,
    y1: 60.713,
    x2: 181.894,
    y2: 61.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0478432,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#FF1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    stopColor: "#FF1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7936,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8443,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9592,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25754_24642",
    x1: 214.422,
    y1: 127.866,
    x2: 212.072,
    y2: 127.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1131,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_25754_24642",
    x1: 234.639,
    y1: 108.852,
    x2: 231.996,
    y2: 107.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_25754_24642",
    x1: 230.281,
    y1: 39.9894,
    x2: 229.858,
    y2: 43.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1859,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3267,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5906,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7154,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9504,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_25754_24642",
    x1: 85.1877,
    y1: 54.0042,
    x2: 84.6011,
    y2: 50.9331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_25754_24642",
    x1: 85.2787,
    y1: 118.164,
    x2: 87.8086,
    y2: 119.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_25754_24642",
    x1: 72.2321,
    y1: 69.679,
    x2: 70.0804,
    y2: 70.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1859,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3267,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5906,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7154,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9504,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_25754_24642",
    x1: 91.5718,
    y1: 81.0999,
    x2: 95.8155,
    y2: 87.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0478432,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#FF1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#FF5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FF3F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    stopColor: "#FF1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7936,
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8443,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9592,
    stopColor: "#AE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_25754_24642",
    x1: 254.622,
    y1: 110.415,
    x2: 259,
    y2: 116.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1131,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_25754_24642",
    x1: 251.512,
    y1: 70.0813,
    x2: 255.745,
    y2: 69.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25754_24642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 241,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulation);
export default __webpack_public_path__ + "static/media/congratulation.fe14ea8b244178fccb51f6468b6934e1.svg";
export { ForwardRef as ReactComponent };